import { render, staticRenderFns } from "./content-tab.vue?vue&type=template&id=122a0aee&scoped=true&"
import script from "./content-tab.vue?vue&type=script&lang=js&"
export * from "./content-tab.vue?vue&type=script&lang=js&"
import style0 from "./content-tab.vue?vue&type=style&index=0&id=122a0aee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122a0aee",
  null
  
)

export default component.exports